import { Routes } from "@angular/router";

export const learningCenterDashboardRoutes: Routes = [
  {
    path: "",
    data: {
      tabs: [
        {
          key: "tables",
          title: "DASHBOARD.TABLES",
          routerLink: "tables",
        },
        {
          key: "charts",
          title: "DASHBOARD.CHARTS",
          routerLink: "charts",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        path: "",
        redirectTo: "tables",
        pathMatch: "full",
      },
      {
        path: "tables",
        loadComponent: () => import("./pages/tables/tables.component").then((c) => c.TablesComponent),
      },
      {
        path: "charts",
        loadComponent: () => import("./pages/charts/charts.component").then((c) => c.ChartsComponent),
      },
    ],
  },
];
